<template>
  <div class="wrapper blog-posts">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/bg44.jpg') ;"
      />
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">
              Wir sind stolz auf jedes unserer Projekte mit 123db.
              <br />
              &nbsp;
              <br />
              Hier ein Auszug unserer maßgeschneiderten Lösungen ...
            </h2>
          </div>
        </div>
      </div>
    </div>
    
    <div class="features-5">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <h2 class="title">
              Branchenlösung Bewachung
            </h2>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons location_world" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Personaleinsatzplanung
                </h4>
                <p>Definieren Sie einen Mitarbeiterpool, vergeben Sie Soll-Einsatzzeiten inklusive der geplanten Tätigkeit: Alles direkt in der Wochenansicht des Projekts per Drag & Drop.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons sport_user-run" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Projektabrechnung
                </h4>
                <p>Wenn alle Ist-Zeiten der Mitarbeiter erfasst sind, berechnet 123db die Kosten für alle Einsätze aller Mitarbeiter. Inklusive Nachtzulagen, Mehrstunden, Feiertagszuschläge, Kilometergeld: Ein Klick genügt.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons ui-2_time-alarm" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Vorbereitung Lohnverrechnung
                </h4>
                <p>Die für die Projektabrechnung bereits verwendeten Daten sind pro Mitarbeiter und Monat für die Lohnverrechnung abruf- und exportierbar. Auch die Dokumentation für Mitarbeiteranmeldungen inkl. Tagesanmeldungen kann gepflegt werden. So behalten Sie immer den Überblick.</p>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="tablet-container">
              <img v-lazy="'img/ipad2-inverted.png'">
            </div>
          </div>
        </div>
        
        <hr class="mt-5">
        <div class="row">
          <div class="col-md-5">
            <div class="tablet-container">
              <img v-lazy="'img/ipad2-inverted.png'">
            </div>
          </div>
          <div class="col-md-7">
            <h2 class="title">
              Handel mit Waren aller Art
            </h2>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons location_world" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Sales
                </h4>
                <p>Vom Angebot, über Auftrag bis zur Rechnung: Verknüpft, auswertbar, mit individuell anpassbarer Druckvorlage.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons sport_user-run" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Lagerverwaltung
                </h4>
                <p>Verwalten Sie Ihr Warenlager effizient mit 123db. Erfassen Sie Warenbewegungen, überwachen Sie Bestände und generieren Sie
                  Berichte für Ihr individuelles Controlling - Einsehbar direkt auf Ihrem Dashboard.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons ui-2_time-alarm" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Preisgestaltung
                </h4>
                <p>Definieren Sie individuelle Preise für Ihre Produkte oder Dienstleistungen. Ob berechnete Preise (z.B. Aufschläge auf Lieferantenpreise),
                  Staffelpreise oder einfache Fixpreise mit einem Gültigkeitszeitraum.</p>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-5">
        <div class="row">
          <div class="col-md-7">
            <h2 class="title">
              Pflegedokumentation
            </h2>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons location_world" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Gesamtüberblick pro Standort/Mitarbeiter
                </h4>
                <p>Sehen Sie auf einen Blick, ob alle Klient:innen anwesend sind, die Dokumentation gemacht wurde und ob alle Medikamente bereigstellt wurden.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons sport_user-run" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Einfache Handhabung
                </h4>
                <p>Dokumentieren Sie direkt dort, wo Sie sich gerade befinden. Je weniger Zeit mit der Dokumentation verbracht wird, desto mehr Zeit
                bleibt für die Arbeit mit den Klient:innen.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons ui-2_time-alarm" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Zentrale Datenerfassung - überall verfügbar
                </h4>
                <p>Kein Zettel, der mühsam abgetippt werden muss, kein medizinisch relevanter Wert, der nicht dort ist wo er hingehört - die Dokumentation
                ist vollständig dort, wo sie sein soll und kann jederzeit gegenüber Dritten oder Behörden lückenlos vorgewiesen werden.</p>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="tablet-container">
              <img v-lazy="'img/ipad2-inverted.png'">
            </div>
          </div>
        </div>
        <!--
        <hr class="mt-5">
        <div class="row">
          <div class="col-md-5">
            <div class="tablet-container">
              <img v-lazy="'img/ipad2-inverted.png'">
            </div>
          </div>
          <div class="col-md-7">
            <h2 class="title">
              Fragebogen
            </h2>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons location_world" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Hundreds of Components
                </h4>
                <p>The moment you use Now UI Kit, you know you’ve never felt anything like it. With a single use lets you do more than ever before. </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons sport_user-run" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Easy to Use
                </h4>
                <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons ui-2_time-alarm" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Fast Prototyping
                </h4>
                <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p>
              </div>
            </div>
          </div>
        </div>
  -->
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from '@/components';

  export default {
    components: {
      Card
    }
  }
</script>
<style>
</style>
